import { t } from "@impero-com/common/utils/i18n";
import {
    notifyRequestError,
    queryClient,
} from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";

import {
    getGetUsersUserIdRiskDirectoriesQueryKey,
    usePatchUsersUserIdRiskDirectories,
} from "api/generated/users/users";
import { STATUS_CODE_ERROR_OPERATION_FAILED } from "utils/errorCodes";

import { invalidateAssignmentCountQuery } from "./useAssignmentCountQuery";

export function useUpdateRiskDirectoryRightsForUserMutation() {
    return usePatchUsersUserIdRiskDirectories({
        mutation: {
            onSuccess: async (_response, { userId }) => {
                emitNotification(
                    "success",
                    t("UserManagement_RiskDirectoriesUpdated")
                );
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey:
                            getGetUsersUserIdRiskDirectoriesQueryKey(userId),
                    }),
                    invalidateAssignmentCountQuery(userId.toString()),
                ]);
            },
            onError: (error) => {
                // 460 error is handled by the caller via a modal, so we don't toast it here
                if (
                    error.response?.status ===
                    STATUS_CODE_ERROR_OPERATION_FAILED
                ) {
                    return;
                }
                notifyRequestError(error);
            },
        },
    });
}
